import { render, staticRenderFns } from "./promotionAdmin.vue?vue&type=template&id=68f62ce3&scoped=true&"
import script from "./promotionAdmin.vue?vue&type=script&lang=js&"
export * from "./promotionAdmin.vue?vue&type=script&lang=js&"
import style0 from "./promotionAdmin.vue?vue&type=style&index=0&id=68f62ce3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f62ce3",
  null
  
)

export default component.exports